export const buildFileName = (stringLabel: string, dateLabel: string): string => {
  const maxLength = 256; // string restriction for file name
  const safeDateLabel = dateLabel ?? '';
  const suffix = `_${safeDateLabel}.xlsx`;
  const maxEventLength = Math.max(0, maxLength - stringLabel.length - suffix.length);
  const truncatedEventName = stringLabel.slice(0, maxEventLength);

  return `${truncatedEventName}${suffix}`;
};
